import { useMemo, useState, useEffect } from "react";

import { useSummaryStyles } from "./summary.styles";
import { calculateTimeLeft } from "../../../../app/utils";

export const Timer = ({ date, handleTooltipClose }: { date: Date; handleTooltipClose: () => void }) => {
  const classes = useSummaryStyles();
  const initialTimeLeft = useMemo(() => calculateTimeLeft(date), [date]);

  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTimeLeft = calculateTimeLeft(date);
      if (currentTimeLeft === null) {
        clearInterval(interval);
      }
      setTimeLeft(currentTimeLeft);

      if (currentTimeLeft?.minutes === 0 && currentTimeLeft.seconds === 0) handleTooltipClose();
    }, 1000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  return (
    <span className={classes.timer}>
      {("0" + (timeLeft?.minutes || 0)).slice(-2) || "00"}:{("0" + (timeLeft?.seconds || 0)).slice(-2) || "00"}
    </span>
  );
};
